import { ThemeUIStyleObject } from 'theme-ui';
import GenericProductCard from '~/components/GenericProductCard';
import { useBadge } from '~/hooks/components/use-badge';
import useProductCardImage from '~/hooks/components/useProductCardImage';
import { Image } from '~/types';
type Props = {
  forwardSx?: ThemeUIStyleObject;
  wrapperSx?: ThemeUIStyleObject;
  variant: Queries.VariantCardFragmentFragment;
  collectionSlug?: string;
  isFeatured: boolean;
  cardDirection: boolean | null;
  cardMicroloadHighlight?: string;
  renderPrice?: boolean;
  bgColor?: string;
  mainImage: Image;
  featuredImage?: Image;
  cdpCopy?: string;
};

const VariantCard = ({
  forwardSx = {},
  wrapperSx = {},
  variant,
  collectionSlug,
  isFeatured,
  cardDirection,
  cardMicroloadHighlight,
  renderPrice,
  bgColor,
  mainImage,
  featuredImage,
  cdpCopy,
}: Props) => {
  const badges = variant?.product?.[0]?.badges;
  const badge = useBadge({ selectedOption: variant, badges: badges as Queries.BadgeFragment[] });
  const { productCardImage: currentImage } = useProductCardImage({
    desktopImage: isFeatured ? featuredImage ?? mainImage : mainImage,
    mobileImage: mainImage,
  });

  const { product, price, regularPrice } = variant;

  const optionValues = variant?.optionValues;

  const collection = collectionSlug ?? product?.[0]?.collection?.[0]?.slug;
  const color = optionValues?.find((ov) => ov?.option_type?.[0]?.slug === 'color')?.presentation;
  const queryString = color ? `color=${encodeURIComponent(color)}` : null;
  const slug = product?.[0]?.slug;
  return (
    <GenericProductCard
      forwardSx={forwardSx}
      wrapperSx={wrapperSx}
      isFeatured={false}
      cardDirection={cardDirection}
      title={product?.[0]?.longTitle ?? ''}
      renderPrice={renderPrice}
      bgColor={bgColor ?? 'cloud'}
      slug={slug ?? ''}
      queryString={queryString ?? ''}
      price={price}
      regularPrice={regularPrice}
      name={product?.[0]?.title ?? ''}
      collectionSlug={collectionSlug ?? collection}
      badge={badge}
      currentImage={currentImage}
      cardMicroloadHighlight={cardMicroloadHighlight}
      cdpCopy={cdpCopy}
    />
  );
};

export default VariantCard;
